<template>
  <div class="userinfo-change-form">
    <div class="form-body">
      <el-form :model="formData" label-width="120px" ref="userinfoChangeForm" :rules="formRules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="计划户名称:" prop="name">
              <el-input v-model="formData.name" placeholder="请输入计划户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系人:" prop="contact_man">
              <el-input v-model="formData.contact_man" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系电话:" prop="contact_phone">
              <el-input v-model="formData.contact_phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属镇街:" prop="addr_id">
              <select-addr v-model="formData.addr_id"></select-addr>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址:" prop="addr_detail">
              <el-input v-model="formData.addr_detail" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="邮政编码:" prop="postal_code">
              <el-input v-model="formData.postal_code" placeholder="请输入邮政编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="绿化面积:" prop="green_area">
              <el-input v-model="formData.green_area" placeholder="请输入绿化面积"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="dialog-footer clearfix" slot="footer">
      <div class="tools-box">
        <div class="tools-item">
          <el-button @click="handleCancel" size="mini">取消</el-button>
        </div>
        <div class="tools-item">
          <el-button @click="handleConfirm" type="success" size="mini">提交</el-button>
        </div>
      </div>
    </div>

    <hd-loading v-if="pageLoading"></hd-loading>
  </div>
</template>

<script>
import selectAddr from "@/components/util/selectAddr.vue"
import {
  A_UICL_Edit
} from '@/assets/js/axiosPresets'
export default {
  components: {
    selectAddr
  },
  data () {
    return {
      tableData: [
        { filed: 'name', name: '计划户名称' },
        { filed: 'contact_man', name: '联系人' },
        { filed: 'contact_phone', name: '联系电话' },
        { filed: 'addr_id', name: '地区' },
        { filed: 'addr_detail', name: '详细地址' },
        { filed: 'postal_code', name: '邮政编码' },
        { filed: 'green_area', name: '绿化面积' }
      ],
      pageLoading: false,
      formData: {},
      formRules: {
        name: [
          { required: true, message: '请输入计划户名称', trigger: 'blur' }
        ],
        contact_man: [
          { required: true, message: '请输入联系人名称', trigger: 'blur' }
        ],
        contact_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        addr_id: [
          { required: true, message: '请选择所属镇街', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo || {}
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      handler (val) {
        console.log(val)
        this.formData = {
          name: val.name || null,
          contact_man: val.contact_man || null,
          contact_phone: val.contact_phone || null,
          addr_id: val.addr_id || null,
          addr_detail: val.addr_detail || null,
          postal_code: val.postal_code || null,
          green_area: val.green_area || null
        }
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('cancel')
    },
    async handleConfirm () {
      // 校验表单
      const valid = await this.$refs.userinfoChangeForm.validate()
      const _diff = []
      this.tableData.forEach(item => {
        const key = item.filed
        const name = item.name
        if (!this.formData[key] && !this.userInfo[key]) {
          return
        }
        if (this.formData[key] !== this.userInfo[key]) {
          _diff.push({
            field: key,
            name: name,
            after_value: this.formData[key]
          })
        }
      })
      if (_diff.length === 0) {
        this.$message.warning("无变更信息，请修改需要变更的字段！")
        return false
      }
      await this.$confirm('确认保存？')
      this.pageLoading = true
      const res = await this.$F_checkAxiosIn(A_UICL_Edit({
        user_id: this.userInfo.oid,
        child_list: _diff
      }))
      this.pageLoading = false
      if (!res) {
        return
      }
      this.$message({
        showClose: true,
        message: '操作成功！',
        type: 'success'
      })
      this.$emit('successThen')
    }
  }
}
</script>

<style lang="scss" scoped>
.userinfo-change-form {
  .form-body {
    padding: 6px;
  }
  .tools-box {
    float: right;
    padding: 5px;
    .tools-item {
      display: inline-block;
      margin-left: 6px;
    }
  }
}
</style>